import React from "react"
import cn from "classnames"

type Props = {
    onChange?: (checked: boolean) => void
    checked?: boolean
    id?: string
    className?: string
}
export const Toggle = ({ onChange, checked, id, className }: Props) => {
    const onChangeHandler = (event) => {
        const checked = event.target.checked
        onChange?.(checked)
    }

    return (
        <div className={cn("custom-toggle", className)}>
            <input type="checkbox" id={id} onChange={onChangeHandler} checked={checked} />
            <svg width="29" height="12" viewBox="0 0 29 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="29" height="12" rx="6" fill="#3B3060" className="holder" />
                <circle cx="8" cy="6" r="4" fill="#CC78FF" className="switch" />
            </svg>
        </div>
    )
}
